export default "__VITE_ASSET__COfU3og2__"